/** @deprecated legacy key — cleared when preview param is absent */
export const MARKET_PULSE_PREVIEW_STORAGE_KEY = 'market_pulse_preview_coming_soon';

function hasComingSoonPreviewParam(params: URLSearchParams): boolean {
  return params.get('preview') === 'coming-soon';
}

function clearStalePreviewStorage(): void {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(MARKET_PULSE_PREVIEW_STORAGE_KEY);
}

/** No-op kept for BranchContext imports — preview is URL-only now. */
export function syncMarketPulsePreviewFromUrl(): void {
  if (typeof window === 'undefined') return;
  const params = new URLSearchParams(window.location.search);
  if (!hasComingSoonPreviewParam(params)) {
    clearStalePreviewStorage();
  }
}

/** Force Coming Soon only when ?preview=coming-soon is in the current URL. */
export function isMarketPulseComingSoonPreview(): boolean {
  if (typeof window === 'undefined') return false;

  const params = new URLSearchParams(window.location.search);
  if (hasComingSoonPreviewParam(params)) return true;

  clearStalePreviewStorage();
  return false;
}

export function applyPreservedSearchParams(prev: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(prev);
  if (hasComingSoonPreviewParam(prev)) {
    next.set('preview', 'coming-soon');
  }
  return next;
}

export function clearedSearchParamsPreservingPreview(prev: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams();
  if (hasComingSoonPreviewParam(prev)) {
    next.set('preview', 'coming-soon');
  }
  return next;
}
